import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { NOTIFICATIONS_IN_APP_OBRA_COUNT_QUERY_KEY } from 'Data/keys/QueryKeys';
import { NotificationApiV2 } from 'Data/Notification.api.v2';

export const useQueryCountInAppObrasNotifications = () => {
  const { data, refetch, isLoading, isFetching, error } = useQuery({
    queryKey: [NOTIFICATIONS_IN_APP_OBRA_COUNT_QUERY_KEY],
    staleTime: 60 * 5 * 1000, // 5 minutes
    queryFn: async () => {
      const response = await NotificationApiV2.countInAppObrasNotifications();
      return response.data.data;
    },
  });

  const dataDefault = useMemo(() => [], []);

  return {
    data: data ?? dataDefault,
    refetch,
    isLoading,
    isFetching,
    error,
  };
};
